import { LOGIN } from "../../common/apiUrl/login/loginUrls";
import { LoginJsonRequest, RefreshTokenJsonRequest } from "../../common/model/login/jsonRequest";
import { generateCurlCommand } from "../helperFunctions";

const loginJsonRequest: LoginJsonRequest = {
    "email": "testemail@test.com",
    "password": "testPassword"
}

const refreshTokenJsonRequest: RefreshTokenJsonRequest = {
    "refreshToken": "string"
}

export const loginJsonRequestCurl = generateCurlCommand(
    LOGIN.LOGIN_URL,
    "POST",
    loginJsonRequest
)

export const refreshTokenJsonRequestCurl = generateCurlCommand(
    LOGIN.REFRESH_TOKEN_URL,
    "POST",
    refreshTokenJsonRequest
)